export const notificationState = {
  loading: false,
  response: null,
  error: false,
};
